import React, { useMemo } from "react";
import { AsyncPaginate } from "react-select-async-paginate";

const sanitizeValue = (val, isMulti) => {
    if (isMulti) {
        if (!Array.isArray(val)) return [];
        return val.filter(
            (v) =>
                v &&
                typeof v === "object" &&
                v.value !== undefined &&
                v.label !== undefined
        );
    } else {
        if (Array.isArray(val)) return val[0] || null;
        if (val && typeof val === "object" && val.value !== undefined) return val;
        return null;
    }
};

const EmployeeSelect = ({
    value,
    onChange,
    loadEmployees,
    isMulti = false,
    placeholder = "Select Employee",
    onAddEmployee,
    styles: customStyles = {},
    isSearchable = true,
    isClearable = true,
    cacheUniqs = []
}) => {
    const safeValue = useMemo(() => sanitizeValue(value, isMulti), [value, isMulti]);

    const defaultStyles = {
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        ...customStyles
    };

    return (
        <AsyncPaginate
            isMulti={isMulti}
            isSearchable={isSearchable}
            isClearable={isClearable}
            value={safeValue}
            cacheUniqs={cacheUniqs}
            loadOptions={async (search, loadedOptions, additional) => {
                const res = await loadEmployees(search, loadedOptions, additional);
                let options = res?.options || [];

                // ➕ ADD EMPLOYEE OPTION (Only if callback provided)
                if (onAddEmployee && loadedOptions.length === 0 && !options.some(o => o.value === "__ADD_EMPLOYEE__")) {
                    options.unshift({
                        value: "__ADD_EMPLOYEE__",
                        label: "+ Add Employee"
                    });
                }

                return {
                    ...res,
                    options
                };
            }}
            onChange={(val) => {
                const selected = sanitizeValue(val, isMulti);
                if (isMulti) {
                    if (selected?.some(v => v.value === "__ADD_EMPLOYEE__")) {
                        if (onAddEmployee) onAddEmployee();
                        return;
                    }
                } else {
                    if (selected?.value === "__ADD_EMPLOYEE__") {
                        if (onAddEmployee) onAddEmployee();
                        return;
                    }
                }
                onChange(selected);
            }}
            placeholder={placeholder}
            additional={{ page: 1 }}
            menuPortalTarget={document.body}
            styles={defaultStyles}
        />
    );
};

export default EmployeeSelect;
